export function sleep( ms:number ):Promise<void>
{
  let promise = new Promise<void>(
    ( resolve, reject )=>
    {
      setTimeout( ()=>{ resolve(); }, ms );
    }
  );

  return promise;
}

export function waitAround( msMin:number, msMax:number ):Promise<void>
{
  let ms = msMin + Math.random() * ( msMax - msMin );

  let promise = new Promise<void>(
    ( resolve, reject )=>
    {
      setTimeout( ()=>{ resolve(); }, ms );
    }
  );

  return promise;
}